import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "components/cards/Card";
import {
  Grid,
  TextField,
  InputAdornment,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import partnersTestData from "testdata/partnersData";
import NoData from "components/NoData";

export default function PartnersPage() {
  const classes = useStyles();
  const [partnersData, setPartnersData] = useState(partnersTestData);
  const [searchData, setSearchData] = useState(partnersTestData);

  useEffect(() => {}, []);

  const handleSearch = (value) => {
    searchPartnersData(value);
  };

  const searchPartnersData = (value) => {
    let partnersData_ = [];

    for (let i = 0; i < searchData.length; i++) {
      if (
        searchData[i].title.toLowerCase().includes(value.toLowerCase()) ||
        searchData[i].description.toLowerCase().includes(value.toLowerCase())
      ) {
        partnersData_ = [...partnersData_, searchData[i]];
      }
    }

    setPartnersData(partnersData_);
  };

  return (
    <div className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <TextField
            className={classes.inputField}
            placeholder="Search Partners"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Grid>
        {partnersData.length > 0 ? (
          partnersData.map((partnerData) => (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card className={classes.partnerInfoCardView}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <CardMedia
                      image={partnerData.image}
                      className={classes.partnerInfoImage}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}
                    className={classes.partnersInfoGrid}
                  >
                    <CardContent>
                      <Typography
                        className={classes.partnerInfoTitle}
                        component={"h2"}
                      >
                        {partnerData.title}
                      </Typography>
                      <Typography
                        className={classes.partnerInfoDescription}
                        component={"h2"}
                      >
                        {partnerData.description}
                      </Typography>
                    </CardContent>
                    <Button
                      className={classes.websiteButton}
                      variant="contained"
                      href={partnerData.website_url}
                      target="_blank"
                    >
                      Visit Website
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <NoData />
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    minHeight: 400,
  },
  inputField: {
    width: "100%",
    height: 36,
    background: "#F9F9F9",
    "& .MuiOutlinedInput-root": {
      height: 36,
    },
  },
  partnerInfoCardView: {
    "& span": {
      fontFamily: "Proxima Nova, sans-serif !important",
    },
    "& .MuiCardContent-root": {
      padding: 0,
    },
  },
  partnerInfoImage: {
    width: "auto",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "300px",
    },
  },
  partnersInfoGrid: {
    paddingTop: "40px !important",
    paddingRight: "40px !important",
    paddingBottom: "40px !important",
    [theme.breakpoints.down("xs")]: {
      padding: "3px 30px 30px 30px !important",
    },
  },
  partnerInfoTitle: {
    padding: "10px 0px",
    fontSize: 20,
    fontWeight: "bold",
  },
  websiteButton: {
    marginTop: 10,
    width: 135,
    fontSize: 12,
    backgroundColor: `${theme.palette.primary.primaryButton} !important`,
    color: `${theme.palette.primary.primaryButtonLabel} !important`,
  },
}));
